import logo from './logo.svg';
import './App.css';
import EmailVaildator from './EmailVaildator';
import {
  GoogleReCaptchaProvider,
  useGoogleReCaptcha,
  GoogleReCaptcha,
  withGoogleReCaptcha
} from 'react-google-recaptcha-v3';
import { useCallback, useEffect, useState } from 'react';
import NeverBounceEmailValidator from './NeverBounceEmailValidator';

function App() {
  const [captchaToken,setcaptchaToken] = useState("");
  const [refreshCaptcha,setrefreshCaptcha] = useState(false);
 
  const { executeRecaptcha } = useGoogleReCaptcha();
  const onValidationFormSubmit = useCallback(
    (token) => {
      setrefreshCaptcha(false);
      console.log(token)
      setcaptchaToken (token+"");
      if (!executeRecaptcha) {
        console.log('Not initialized')
        return
      };
    },
    [executeRecaptcha]
  );


  function newToken (){
    setrefreshCaptcha(true)
  }

  useEffect(()=>{

  },[onValidationFormSubmit])
  return (
    <div className="App h-100">
      <GoogleReCaptchaProvider reCaptchaKey="6LcE1dMmAAAAAHDMyAmubptIJhdLLCBIrjJTOa8Q" >
      <GoogleReCaptcha onVerify={onValidationFormSubmit}  refreshReCaptcha={refreshCaptcha}/>
        {/* <EmailVaildator token={captchaToken} renewToken={newToken} /> */}
        <NeverBounceEmailValidator token={captchaToken} renewToken={newToken} />

      </GoogleReCaptchaProvider> 
    </div>
  );
}

export default App;
